
namespace Riepiloghi.Negozio {

    @Serenity.Decorators.registerClass()
    export class RiepiloghiDialog extends Serenity.EntityDialog<RiepiloghiRow, any> {
        protected getFormKey() { return RiepiloghiForm.formKey; }
        protected getIdProperty() { return RiepiloghiRow.idProperty; }
        protected getLocalTextPrefix() { return RiepiloghiRow.localTextPrefix; }
        protected getService() { return RiepiloghiService.baseUrl; }
        protected getDeletePermission() { return RiepiloghiRow.deletePermission; }
        protected getInsertPermission() { return RiepiloghiRow.insertPermission; }
        protected getUpdatePermission() { return RiepiloghiRow.updatePermission; }

        protected form = new RiepiloghiForm(this.idPrefix);

    }
}